import React from 'react'
import { useNavigate } from 'react-router-dom'
import { l, Link } from '@manychat/manyui'

import { linkURL } from 'utils/url'

import cm from './common.module.css'

export const SmbAppDisconnected = () => {
  const navigate = useNavigate()
  return (
    <span>
      {l.translate(
        'Your WhatsApp account was disconnected from Manychat due to a Meta issue. Your contacts and chats are safe. Restore the connection ',
      )}
      <Link className={cm.link} onClick={() => navigate(linkURL('/settings#whatsApp'))}>
        {l.translate('in settings')}
      </Link>
    </span>
  )
}
